// extracted by mini-css-extract-plugin
export default {"phoneItem":"SiteFooter_phoneItem__d9hSw","phone":"SiteFooter_phone__KA9BK","modalLink":"SiteFooter_modalLink__tlUr5"};